import Almond from "./Almond";

export default Almond;